import React, { useState } from "react";

import "./SwitchOrder.css";

function SwitchOrder({ onChange }) {
    const [upcomingSelected, setUpcomingSelected] = useState(true);
  return (
    <div className="togl">
          <input
              id="toggle-on"
              className="toggle toggle-left"
              name="toggle"
              value="true"
              type="radio"
              checked={upcomingSelected}
              onChange={(e) => (setUpcomingSelected(true), onChange(true))}
          ></input>
      <label htmlFor="toggle-on" className="btn">
              Upcoming
      </label>
          <input
              id="toggle-off"
              className="toggle toggle-right"
              name="toggle"
              value="false"
              type="radio"
              checked={!upcomingSelected}
              onChange={(e, v) => (setUpcomingSelected(false), onChange(false))}
          />
      <label htmlFor="toggle-off" className="btn">
              Past Orders
      </label>
    </div>
  );
}

export default SwitchOrder;
